export const LOAD_USER_SUBSCRIPTIONS = 'LOAD_USER_SUBSCRIPTIONS';

export const loadUserSubscriptions = () => ({
  type: LOAD_USER_SUBSCRIPTIONS
});
